import React from "react";

export const MainPageFooter = () => {
  return (
    <footer className="l-footer">
      <p>© Hospital Veterinario Peninsular</p>

      <ul className="l-footer_social">
        <li>
          <a
            className="l-footer_link"
            href="https://www.facebook.com/HospitalVeterinarioPeninsular"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="l-footer_icon fab fa-facebook"></i>
          </a>
        </li>
        <li>
          <a
            className="l-footer_link"
            href="https://www.instagram.com/hospitalveterinariopeninsular"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="l-footer_icon fab fa-instagram"></i>
          </a>
        </li>
        <li>
          <a
            className="l-footer_link"
            href="https://www.youtube.com/channel/UCmlztTxVkVxaNS-PdDMQmBA"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="l-footer_icon fab fa-youtube"></i>
          </a>
        </li>
      </ul>
    </footer>
  );
};
